import { GovFlex } from '@gov-design-system-ce/react';
import {
	FormCheckbox,
	FormLabel,
	GovFormWeb,
} from '@gov-design-system-ce/react-form';
import { useRezaChangeOptions } from '@gov-nx/core/hooks';
import { REZA_USAGE_FORM_PERMISSIONS, useUsageForm } from '@gov-nx/module/page';
import {
	Button,
	DataBoxSelect,
	Dialog,
	FormDatePicker,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';
import { RezaChangeFormSection } from '../../Reza/RezaChangeFormView/RezaChangeFormSection';
import { RezaChangeFormSkeleton } from '../../Reza/RezaChangeFormView/RezaChangeFormSkeleton';
import { useRezaSwitcherStore } from '@gov-nx/store';

interface UsageModalFormProps {
	isOpen: boolean;
	onClose: () => void;
}

export const UsageModalForm = ({ isOpen, onClose }: UsageModalFormProps) => {
	const { setActiveSwitcherReza } = useRezaSwitcherStore();
	const optionsData = useRezaChangeOptions({
		permissions: REZA_USAGE_FORM_PERMISSIONS,
	});

	const {
		formDefinition,
		isSentByDatabox,
		hasDataBoxes,
		formId,
		isLoading,
		onSubmit,
		strings,
	} = useUsageForm();
	return (
		<Dialog
			isOpen={isOpen}
			onClose={() => {
				setActiveSwitcherReza(null);
				onClose();
			}}
			title={<h3>{strings.title}</h3>}
			footer={
				<Button
					form={formId}
					isLoading={isLoading}
					isDisabled={optionsData.isRezaListLoading}
					nativeType="submit"
					color="primary"
					type="solid">
					{strings.submitButton}
				</Button>
			}>
			<LayoutGap>
				{optionsData.isRezaListLoading ? (
					<RezaChangeFormSkeleton />
				) : (
					<RezaChangeFormSection
						optionsData={optionsData}
						setActiveSwitcherReza={setActiveSwitcherReza}
						autoSubmitOnChange
					/>
				)}
				<GovFormWeb
					id={formId}
					formDefinition={formDefinition}
					onSubmit={onSubmit}>
					<LayoutGap>
						<section>
							<FormLabel>{strings.dateRangeLabel}</FormLabel>
							<GovFlex gap="m">
								<FormWidthElementLayout>
									<FormDatePicker {...formDefinition.fields.datumOd} />
								</FormWidthElementLayout>
								<FormWidthElementLayout>
									<FormDatePicker {...formDefinition.fields.datumDo} />
								</FormWidthElementLayout>
							</GovFlex>
						</section>
						{hasDataBoxes ? (
							<>
								<FormCheckbox {...formDefinition.fields.sendByDatabox} />
								{isSentByDatabox ? (
									<DataBoxSelect {...formDefinition.fields.datovaSchrankaId} />
								) : null}
							</>
						) : null}
					</LayoutGap>
				</GovFormWeb>
			</LayoutGap>
		</Dialog>
	);
};
